import { useAuth } from 'app/providers/auth/AuthProvider'
import { useCallback, useEffect, useRef, useState } from 'react'
import {
  getScheduleDoctorRailOrder,
  setScheduleDoctorRailOrder,
} from './scheduleDoctorRailOrderStorage'
import { mergeReorderedDoctorRailIds } from './scheduleInstance'

export const useScheduleDoctorRailOrder = () => {
  const { userId } = useAuth()
  const [doctorRailOrder, setDoctorRailOrder] = useState<number[]>(() =>
    getScheduleDoctorRailOrder(userId),
  )
  const doctorRailOrderRef = useRef(doctorRailOrder)
  doctorRailOrderRef.current = doctorRailOrder

  useEffect(() => {
    const stored = getScheduleDoctorRailOrder(userId)
    doctorRailOrderRef.current = stored
    setDoctorRailOrder(stored)
  }, [userId])

  const saveDoctorRailOrder = useCallback(
    (nextVisibleIds: number[]) => {
      const next = setScheduleDoctorRailOrder(
        userId,
        mergeReorderedDoctorRailIds(doctorRailOrderRef.current, nextVisibleIds),
      )
      doctorRailOrderRef.current = next
      setDoctorRailOrder(next)
    },
    [userId],
  )

  return { doctorRailOrder, saveDoctorRailOrder }
}
